<template>
  <div>
    <el-row class="el-row">
      <div class="left_l">
        <el-button type="primary" @click="verifyFirm">验证固件</el-button>
        <el-tooltip content="请先验证固件，再进行升级" placement="top" effect="light" :disabled="firmwareData.verifyStatus === 1? true : false">
          <div  class="btn-wrap" >
            <el-button
            :disabled="firmwareData.verifyStatus === 1? false : true"
            @click="update"
            >
              批量升级
            </el-button>
          </div>
        </el-tooltip>
      </div>
      <div class="left_r">
        <el-input
        placeholder="请输入批次ID"
        v-model="strategyInput"
        @focus="inputFocus"
        @blur="inputBlur"
        :class="active ? 'active' : '' "
        @keyup.13.native="handlerKeyUp"
        >
          <el-button slot="append" icon="el-icon-search" @click="clickHandlerById" ></el-button>
        </el-input>
      </div>
    </el-row>
    <!-- table表格 -->
    <el-table
      :show-overflow-tooltip="true"
      :header-cell-style="{background:'#eef1f6',color:'#606266'}"
      :data="tableData"
      @filter-change="filterChange"
      class="table">
      <el-table-column
        prop="strategyId"
        label="批次ID"
        width="180">
      </el-table-column>
      <el-table-column
        prop="sourceVersions"
        label="待升级版本号">
      </el-table-column>
      <el-table-column
        prop="batchType"
        label="批次类型">
      </el-table-column>
      <el-table-column
        prop="strategyType"
        label="升级策略">
      </el-table-column>
      <el-table-column
        prop="batchStatus"
        label="状态"
        column-key="batchStatus"
        :filter-multiple="false"
        :filters="tableFilterData"
        filter-placement="bottom-end"
        >
          <template slot-scope="scope">
          <span class="tip" :style="{background:(scope.row.batchStatus === 1 ? 'pink': scope.row.batchStatus === 2 ? '#0070cc': scope.row.batchStatus === 3 ? 'green' : scope.row.batchStatus === 4 ? '#ff8a00' : '')}"></span>
          <span style="margin-right: left">{{ scope.row.batchStatus === 1 ? '待升级': scope.row.batchStatus === 2 ? '升级中': scope.row.batchStatus === 3 ? '已完成' : scope.row.batchStatus === 4 ? '已取消' : '' }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="createTime"
        label="添加时间">
      </el-table-column>
      <el-table-column
        label="操作">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="view(scope.row)">查看</el-button>
          <el-popover
            placement="top"
            width="400"
            iconColor="red"
            :ref="`popover-${scope.$index}`"
            class="pop">
           <!--  <el-checkbox v-model="checked" class="check-box">取消批次下所有正在进行中的升级任务
              (如不勾选，默认置灰取消动态升级策略)</el-checkbox>    TODO:该功能暂时不做-->
             <p><span class="el-icon-info" style="padding:4px"></span>确定要取消批量升级吗？</p>
            <div style="text-align: right; margin: 0">
              <el-button size="mini" type="text" @click="handleClose(scope.$index)">取消</el-button>
              <el-button type="primary" size="mini" @click="cancelBatchUpgrade(scope.row,scope.$index)">确定</el-button>
            </div>
            <el-button type="text" size="small" slot="reference" v-if="scope.row.batchStatus === 2">
                | 取消
            </el-button>
          </el-popover>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页管理 -->
    <Paging :total="total" @changePage="changePage"/>
    <!-- 验证固件组件 -->
    <VerifyFirmware
    v-if="verifyDialogFlag"
    :verifyDialogFlag="verifyDialogFlag"
    :rows="rows"
    :date="date"
    ref="verifyFirm"
    @reflash='reflash'
    @closeVerifyDialog="verifyDialogFlag = false"></VerifyFirmware>
    <!-- 批量升级 -->
    <BatchUpGrade
    v-if="BatchUpGradeDialogFlag"
    :BatchUpGradeDialogFlag="BatchUpGradeDialogFlag"
    @closeBatchDialog="BatchUpGradeDialogFlag = false"
    :rows="rows"
    :date="udate"
    ref="batchUpgrading"
    @reflash='reflash'></BatchUpGrade>
  </div>
</template>
<script>
import { getStrategyByFirmwareId, cancelUpgrade } from '@/api/productControl'
import Paging from '@/components/paging'
import VerifyFirmware from '@/components/VerifyFirmwareDialog/index.vue'
import BatchUpGrade from '@/components/VerifyFirmwareDialog/batchUpGradings.vue'
export default {
  props: {
    firmwareData: {
      type: Object,
      default: function () {
        return ''
      }
    }
  },
  components: {
    VerifyFirmware,
    BatchUpGrade,
    Paging
  },
  data () {
    return {
      // 分页功能
      total: 0, // 到时候从后台获取
      listLoading: false, // 根据loading来进行显示/隐藏
      listQuery: {
        page: 1,
        limit: 10
      },
      active: false,
      strategyInput: '', // 批次ID
      deviceInput: '', // 设备ID
      tableData: [],
      VerifyFirmware: true,
      params: { // 请求参数
        firmwareId: this.firmwareData.firmwareId
      },
      multipleSelection: [], // 选择框选的数量
      checked: true,
      tableFilterData: [
        { text: '待升级', value: 1 },
        { text: '升级中', value: 2 },
        { text: '已完成', value: 3 },
        { text: '已取消', value: 4 }
      ],
      rows: {}, // 传给组件的数据
      date: Date.parse(new Date()),
      udate: Date.parse(new Date()),
      verifyDialogFlag: false,
      BatchUpGradeDialogFlag: false
    }
  },
  created () {
  },
  mounted () {
    this.getStrategyList()
  },
  methods: {
    // 关闭prop弹窗
    handleClose (index) {
      this.$refs[`popover-${index}`].doClose()
    },
    // 验证固件
    verifyFirm () {
      this.rows = this.firmwareData
      this.date = Date.parse(new Date())
      // this.$refs.verifyFirm.dialogFormVisible = true
      this.verifyDialogFlag = true
    },
    reflash () {
      this.getStrategyList()
    },
    // 重新加载
    reLoad () {
      window.location.reload()
    },
    // 查看
    view (row) {
      console.log('JSON.stringify(row)', JSON.stringify(row))
      this.$router.push({
        path: '/SystemOper/firmwareBatchDetail',
        query: ({ row: JSON.stringify(row) })
      })
    },
    // 获取批次升级列表
    getStrategyList () {
      this.params.pageNum = this.listQuery.page
      this.params.pageSize = this.listQuery.limit
      const params = {
        params: this.params
      }
      getStrategyByFirmwareId(params)
        .then((e) => {
          this.total = e.data.data.total
          this.tableData = e.data.data.list
          this.tableData.forEach(item => {
            if (item.batchType === 0) {
              item.batchType = '验证固件'
            } else if (item.batchType === 2) {
              item.batchType = '重验证固件'
            } else {
              item.batchType = '批次升级'
            }
            if (item.strategyType === 0) {
              item.strategyType = '灰度升级'
            } else {
              item.strategyType = '全量升级'
            }
          })
        })
    },
    // table组件筛选功能
    filterChange (filters) {
      if (filters.batchStatus) {
        this.params.batchStatus = filters.batchStatus[0]
      }
      this.getStrategyList()
    },
    // 批量升级
    update () {
      // this.dialogFormVisible = true
      this.rows = this.firmwareData
      this.udate = Date.parse(new Date())
      // this.$refs.batchUpgrading.dialogFormVisible = true
      this.BatchUpGradeDialogFlag = true
    },
    // 输入框聚焦
    inputFocus () {
      this.active = true
    },
    // 输入框失焦
    inputBlur () {
      this.active = false
    },
    // 13键
    handlerKeyUp (e) {
      if (e.keyCode === 13) {
        this.listQuery.page = 1
        this.clickHandlerById()
      }
    },
    // 通过批次id搜索
    clickHandlerById () {
      this.listQuery.page = 1
      this.params.strategyId = this.strategyInput
      this.getStrategyList()
    },
    // 分页管理
    changePage (val) {
      this.listQuery = val
      this.getStrategyList()
    },
    // 取消升级
    cancelBatchUpgrade (val, index) { // TODO:
      const params = {
        params: {
          firmwareId: this.firmwareData.firmwareId,
          strategyId: val.strategyId
        }
      }
      cancelUpgrade(params).then(res => {
        this.$refs[`popover-${index}`].doClose()
        if (res.data.code === 200) {
          this.$message({
            type: 'success',
            message: '取消操作成功'
          })
          setTimeout(() => {
            this.getStrategyList()
          }, 0)
        }
      })
    }
  }
}
</script>

<style lang='less' scoped>
  .el-row{
    margin-bottom: 20px;
    display: flex;
    .left_r{
      width: 20%;
    }
    .btn-wrap{
      margin-left: 10px;
      display: inline-block;
    }
    .el-button{
      border-radius: 0;
    }
    .el-input{
      box-sizing: border-box !important;
      margin-left: 10px;
      border: 1px solid #dedede;
      transition: all .3s ease-out;
      -webkit-transition: all .3s ease-out;
      /deep/ .el-input__inner{
        border: none !important;
        height: 38px;
        line-height: 38px;
      }
      /deep/ .el-input-group__append{
        background-color: white !important;
        color: #555 !important;
        border: none !important;
      }
      /deep/ .el-icon-search{
        color: orange;
        font-size: 20px;
        font-weight: bold;
      }
    }
    .active{
      border-color: #737373;
      transition: all .3s ease-out;
      -webkit-transition: all .3s ease-out;
    }
    .el-input:hover{
      border-color: #737373;
      transition: all .3s ease-out;
      -webkit-transition: all .3s ease-out;
    }
  }
  .table{
    width: 100%;
    margin-bottom: 20px;
    .tip{
      height: 8px;
      width: 8px;
      border-radius: 50%;
      background: #888;
      display: inline-block;
      margin-right: 8px;
    }
  }
  .pagination-container{
    float: right;
  }
  /deep/.el-table__row{
    /deep/ .el-button{
      margin-left: 0;
    }
  }
/*   .check-box{
    display: flex;
  }
  /deep/ .el-checkbox__input{
    margin-top: 2px
  }
  /deep/ .el-checkbox__label{
    white-space: pre-wrap;
  } */
</style>
